/** @format */

import axios from "axios";
import swal from "sweetalert";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { ArrowLeftOutlined, SaveOutlined } from "@ant-design/icons";

import ContentTop from "../../components/ContentTop";
import { header } from "../../../../components/api/Header";
import LoadingCard from "../../../../components/loading/loadingCard";
import { getEnv } from "../../../../lib/env";

function Add(props) {
  const navigate = useNavigate();

  const [date, setDate] = useState("");
  const [data, setData] = useState([]);
  const [ldate, setLdate] = useState(date);
  const [manbalar, setManbalar] = useState([]);
  const [changed, setChanged] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/region/suvdanfoydalanish/manbalar?date=" +
            date,
          header()
        );
        setData(res.data["data"]);
        setManbalar(res.data["manbalar"]);
        setChanged(false);
      } catch (e) {
        console.log("Xato", e);
        alert("Serverga ulanishda xato!");
      } finally {
        setLoading(false);
      }
    };
    if (date) {
      fetchData();
    }
  }, [date]);

  useEffect(() => {
    setDate(ldate);
  }, [ldate]);

  const add = (a, b) => {
    if (!a || typeof a == "undefined" || a === "") {
      a = 0;
    }
    if (!b || typeof b == "undefined" || b === "") {
      b = 0;
    }
    let s = parseFloat(a) + parseFloat(b);
    if (s % 1 == 0) return s;
    return s.toFixed(1);
  };

  const setValue = (index, lx, val) => {
    let datas = [...data];
    if (datas[index]) {
      if (datas[index].data[lx] || datas[index].data[lx] === "") {
        datas[index].data[lx] = val;
        let lim = 0;
        let xaq = 0;
        Object.keys(datas[index].data).map((s, i) => {
          if (i % 2 == 0) {
            lim = add(lim, datas[index].data[s]);
          } else {
            xaq = add(xaq, datas[index].data[s]);
          }
          return null;
        });
        datas[index].limiti = lim;
        datas[index].xaqiqatda = xaq;
        setChanged(true);
      }
    }
    setData(datas);
  };

  const sendToSave = async () => {
    try {
      const res = await axios.post(
        getEnv('REACT_APP_BASE_URL') +
          "/v1/region/suvdanfoydalanish/savetable1",
        { data, date },
        header()
      );
      if (res.data["status"] == 200) {
        swal("Muvaffaqiyatli", res.data["message"], "success", {
          buttons: false,
          timer: 2000,
        });
        navigate("/suvdanfoydalanish");
      } else {
        swal("Xatolik", res.data["message"], "error");
      }
    } catch (e) {
      console.log("Xato", e);
      alert("Server bilan aloqa yo'q!");
    }
  };

  const saveHandler = () => {
    if (data.length == 0) {
      alert("Ma'lumot kiritilmagan!");
    } else if (!changed) {
      alert("Ma'lumotga o'zgartirish kiritmadingiz");
    } else {
      sendToSave();
    }
  };

  return (
    <>
      <ContentTop>
        <ul className='content-top-left suv-omborlari'>
          <NavLink to='/suvdanfoydalanish' className='btn btn-sm btn-primary'>
            <ArrowLeftOutlined />
          </NavLink>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <li
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              color: "#212121",
            }}>
            Suvdan foydalanish
          </li>
        </ul>

        <ul className='content-top-right'>
          <button
            className='btn btn-sm btn-outline-primary d-flex align-items-center'
            onClick={() => saveHandler()}>
            Saqlash&nbsp;&nbsp;&nbsp; <SaveOutlined />
          </button>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <input
            type='date'
            className='form-control form-control-sm'
            value={ldate}
            onChange={(e) => setLdate(e.target.value)}
          />
        </ul>
      </ContentTop>
      {loading ? (
        <LoadingCard heightSize="80vh" loading={loading} />
      ) : (
        <div className='table-box-con'>
          <div className='table-responsive tableFixHead' id='tableFlexible'>
            <table className='table table-bordered table-style' id='tblData'>
              <thead>
                <tr>
                  <th rowSpan={2} scope='col' className='sticky st1'>
                    №
                  </th>

                  <th
                    rowSpan={2}
                    scope='col'
                    className='sticky'
                    style={{ left: "33px" }}>
                    Tumanlar
                  </th>

                  {manbalar
                    ? manbalar.map((m, i) => {
                        return (
                          <th key={i} colSpan={2} scope='col'>
                            {m.manba_nomi}
                          </th>
                        );
                      })
                    : null}
                </tr>

                <tr>
                  {manbalar.length > 0
                    ? Array(manbalar.length * 2)
                        .fill(0)
                        .map((p, i) => {
                          if (i % 2 == 0) {
                            return (
                              <th scope='col' key={i}>
                                Limit
                              </th>
                            );
                          } else {
                            return (
                              <th scope='col' key={i}>
                                Xaqiqat
                              </th>
                            );
                          }
                        })
                    : null}
                </tr>
              </thead>

              {data.length > 0
                ? data.map((d, index) => {
                    return (
                      <tbody key={index}>
                        {index == 1 ? (
                          <tr>
                            <td colSpan={manbalar.length + 3}>
                              <b>Shu Jumladan Tumanlar Chegarasida</b>
                            </td>
                          </tr>
                        ) : null}

                        <tr className={d.name}>
                          <td className='sticky st1'>{d.ind}</td>

                          <td className='sticky' style={{ left: "33px" }}>
                            {d.name}
                          </td>

                          {d.data
                            ? Object.keys(d.data).map((lx, i) => {
                                return (
                                  <td className='inserttr' key={i}>
                                    <input
                                      type='number'
                                      className='insertable'
                                      value={d.data[lx]}
                                      onChange={(e) =>
                                        setValue(index, lx, e.target.value)
                                      }
                                    />
                                  </td>
                                );
                              })
                            : Array(manbalar.length * 2)
                                .fill(0)
                                .map((_, i) => {
                                  return <th scope='col' key={i}></th>;
                                })}
                        </tr>
                      </tbody>
                    );
                  })
                : null}
            </table>
          </div>
        </div>
      )}
    </>
  );
}

export default Add;
